import styled from 'styled-components';

import { colorTokens } from '../../../../shared/components/variables';

export const DriverSummaryContainer = styled.div`
  position: absolute;
  display: flex;
  margin-top: 10px;
  margin-left: 10px;
  align-items: flex-start;
  align-content: flex-start;
  gap: 16px;
  flex-wrap: wrap;
  width: 50%;

  top: 90px;
`;

export const DriverLiveDetailsCard = styled.div`
  display: flex;
  align-items: baseline;
  border: 1px solid ${colorTokens.border.main};
  border-radius: 4px;
  text-decoration: none;
  background-color: #fff;
  padding: 9px;
  gap: 8px;
`;
export const EtaContainer = styled.div<{ $status: string }>`
  background-color: ${(props) => (props.$status === 'late' ? 'rgba(207, 28, 0, 0.08)' : 'none')};
`;

const getColor = {
  late: {
    color: colorTokens.error.main,
  },
  early: {
    color: colorTokens.success.main,
  },
};

export const EtaDiffTag = styled.span<{ $status: string }>`
  color: ${(props) => getColor[props.$status].color};
  border-radius: 4px;
  padding-left: 4px;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.15px;
`;
